"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTruthy = exports.isDefined = exports._trace = exports.isValidFinalSlot = exports.isValidSubsequentSlot = exports.isValidInitialSlot = exports.embedCardRule = exports.isFloated = exports.hasEmbed = exports.isEmbedCard = exports.isAnchorSection = exports.isContentRecommendationSection = exports.resetSlotValues = exports.isGroupedPostsBlock = exports.isWordpressBlock = exports.isTable = exports.isColumns = exports.isList = exports.isParagraph = exports.characterCountForElement = exports.incrementCharacterCount = exports.forceInsertion = exports.slotCounts = exports.slotValues = void 0;
const constants_1 = require("./constants");
const InitialSlotValues = {
    characters: 0,
    embeds: 0,
    forceInsertion: false,
    preventInsertion: false,
    paragraphs: 0,
    reservedSpace: 0,
    sequentialEmbeds: 0,
    totalCharacters: 0,
    totalEmbeds: 0,
    totalParagraphs: 0,
};
exports.slotValues = {
    A: { ...InitialSlotValues },
    B: { ...InitialSlotValues },
    C: { ...InitialSlotValues },
    D: { ...InitialSlotValues },
};
exports.slotCounts = {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
};
function forceInsertion(breakpoint) {
    exports.slotValues[breakpoint].forceInsertion = true;
}
exports.forceInsertion = forceInsertion;
function incrementCharacterCount(amount, breakpoint) {
    exports.slotValues[breakpoint].characters += amount;
    exports.slotValues[breakpoint].reservedSpace = Math.max(0, exports.slotValues[breakpoint].reservedSpace - amount);
}
exports.incrementCharacterCount = incrementCharacterCount;
function getElementType($, $e) {
    if (isParagraph($e)) {
        return 'paragraph';
    }
    else if ($e.is(':header') || ($e[0].children.length === 1 && $($e[0].children[0]).is('strong'))) {
        return 'header';
    }
    else if (isTable($e)) {
        return 'table';
    }
    else if (isList($e)) {
        return 'list';
    }
    else if (isWordpressBlock($e)) {
        return 'wp-block';
    }
    return;
}
function countParagraph(e) {
    let len = 0;
    // Marketing blurbs are essentially house ads; we don't want them
    // to count as paragraphs for the purpose of slot density. We'll
    // accept an slot next to a marketing blurb, but we don't want to
    // potentially bookend the blurb with an slot on either side.
    if (!e.is('aside') || !e[0]?.attribs?.class?.includes('marketing-blurb')) {
        len = e.text().trim().length;
    }
    return len;
}
function countHeader(e) {
    const scale = constants_1.CHARACTER_COUNT_SCALE[e[0].name] || constants_1.CHARACTER_COUNT_SCALE.default;
    const len = Math.round(e.text().trim().length * scale);
    return len;
}
function countList($, e, breakpoint) {
    let len = 0;
    // Descend into list items. Note that we can't embed ads inside
    // a list, and we're going going to treat list items like
    // paragraphs and strictly count text, not inline images etc.
    e.find('li').each(function (_i, item) {
        len += Math.max($(item).text().trim().length, constants_1.ESTIMATED_LINE_LENGTH[breakpoint]);
    });
    return len;
}
function countTable($, e, breakpoint) {
    let len = 0;
    e.find('table tr').each(function (_i, item) {
        len += Math.max($(item).text().trim().length, constants_1.ESTIMATED_LINE_LENGTH[breakpoint]);
    });
    return len;
}
function countWpBlock(e, breakpoint) {
    const blockName = e.attr('data-wp-block-name') ?? '';
    const counts = constants_1.WORDPRESS_BLOCK_CHARACTER_COUNT[blockName] ?? constants_1.WORDPRESS_BLOCK_CHARACTER_COUNT.default;
    return counts[breakpoint];
}
function characterCountForElement($, e, breakpoint, elType) {
    elType ?? (elType = getElementType($, e));
    switch (elType) {
        case 'paragraph':
            return countParagraph(e);
        case 'list':
            return countList($, e, breakpoint);
        case 'header':
            return countHeader(e);
        case 'table':
            return countTable($, e, breakpoint);
        case 'wp-block':
            return countWpBlock(e, breakpoint);
        default:
            return 0;
    }
}
exports.characterCountForElement = characterCountForElement;
function isParagraph(element) {
    const el = element[0];
    return el.type === 'tag' && ['p', 'blockquote', 'aside'].includes(el.tagName);
}
exports.isParagraph = isParagraph;
function isList(element) {
    const el = element[0];
    return el.type === 'tag' && ['ul', 'ol'].includes(el.tagName);
}
exports.isList = isList;
function isColumns(element) {
    return element.attr('data-wp-block-name') === 'core/columns';
}
exports.isColumns = isColumns;
function isTable(element) {
    const el = element[0];
    return ((el.type === 'tag' && el.tagName === 'div' && element.hasClass('m-table')) ||
        element.attr('data-wp-block-name') === 'core/table');
}
exports.isTable = isTable;
function isWordpressBlock(element) {
    return element.attr('data-wp-block-name') !== undefined;
}
exports.isWordpressBlock = isWordpressBlock;
function isGroupedPostsBlock(element) {
    return (element.attr('data-wp-block-name') === 'core/group' &&
        element.has('[data-wp-block-name="the-arena-group/posts"]').length > 0);
}
exports.isGroupedPostsBlock = isGroupedPostsBlock;
function resetSlotValues(breakpoint) {
    const values = exports.slotValues[breakpoint];
    // accumulate to totals
    values.totalCharacters += values.characters;
    values.totalParagraphs += values.paragraphs;
    values.totalEmbeds += values.embeds;
    // used to signal a character spacing requirement before next slot insertion
    values.reservedSpace = 0;
    values.characters = 0;
    values.paragraphs = 0;
    // This includes images
    values.embeds = 0;
    values.sequentialEmbeds = 0;
    values.forceInsertion = false;
}
exports.resetSlotValues = resetSlotValues;
function isContentRecommendationSection(element) {
    const classes = element.attr('class') ?? '';
    return element.is('section') && classes.indexOf('m-in-content-recommendation') !== -1;
}
exports.isContentRecommendationSection = isContentRecommendationSection;
function isAnchorSection(element) {
    const id = element.attr('id');
    return element.is('section') || (id !== undefined && id !== null && id !== '');
}
exports.isAnchorSection = isAnchorSection;
function isEmbedCard(element) {
    return !!element.hasClass('m-embed-card');
}
exports.isEmbedCard = isEmbedCard;
function hasEmbed(element) {
    return element.find(constants_1.EMBED_SELECTOR).length > 0;
}
exports.hasEmbed = hasEmbed;
function isFloated(element) {
    const classes = element.attr('class') ?? '';
    return classes.indexOf('l-wrap-left') !== -1 || classes.indexOf('l-wrap-right') !== -1;
}
exports.isFloated = isFloated;
function embedCardRule($, element, breakpoint) {
    // Count characters until we hit a TML item card
    let next = element;
    let count = 0;
    while (next.length > 0) {
        try {
            next = next.next();
        }
        catch (err) {
            break;
        }
        if (next.length > 0) {
            count += characterCountForElement($, next, breakpoint);
            // there's sufficient content to insert an ad ahead of the next
            // embed card.
            if (count > constants_1.EMBED_CARD_MARGIN[breakpoint]) {
                return true;
            }
            // We found an embed card, but under the margin required for an ad
            if (isEmbedCard(next)) {
                return false;
            }
        }
    }
    return true;
}
exports.embedCardRule = embedCardRule;
function isValidInitialSlot(breakpoint, slotValues, slotInjectionLimits) {
    const totalChars = slotValues.characters + slotValues.embeds * constants_1.embedCharacterEquivalency[breakpoint], limits = slotInjectionLimits[breakpoint];
    return (limits !== null &&
        limits !== undefined &&
        limits.initial.characters !== -1 &&
        totalChars >= limits.initial.characters);
}
exports.isValidInitialSlot = isValidInitialSlot;
function isValidSubsequentSlot(breakpoint, slotValues, slotInjectionLimits) {
    const totalChars = slotValues.characters + slotValues.embeds * constants_1.embedCharacterEquivalency[breakpoint], limits = slotInjectionLimits[breakpoint], requiredChars = limits.subsequent.characters - slotValues.paragraphs * constants_1.lineBreakEquivalency[breakpoint];
    return limits.subsequent.characters !== -1 && totalChars >= requiredChars;
}
exports.isValidSubsequentSlot = isValidSubsequentSlot;
function isValidFinalSlot(breakpoint, slotValues, slotCounts, subsequentSlotThreshold, slotInjectionLimits) {
    /**
     * When calculating subsequent slot insertions, and you reach the end of the content before finding an
     * insertion point, check again with the initial character minimum and using the same set of slot
     * insertion rules as for ‘Subsequent Ad Insertions’.
     */
    const totalChars = slotValues.characters + slotValues.embeds * constants_1.finalSlotEmbedCharacterEquivalency[breakpoint], limits = slotInjectionLimits[breakpoint];
    return ((slotCounts >= subsequentSlotThreshold &&
        isValidSubsequentSlot(breakpoint, slotValues, slotInjectionLimits)) ||
        (slotCounts < subsequentSlotThreshold &&
            isValidInitialSlot(breakpoint, slotValues, slotInjectionLimits)) ||
        (slotCounts === 0 &&
            limits.initial.characters !== -1 &&
            limits.subsequent.characters !== -1 &&
            limits.final.characters !== -1 &&
            totalChars >= limits.final.characters));
}
exports.isValidFinalSlot = isValidFinalSlot;
const ENABLE_TRACING = process.env.AD_CONTAINERS_TRACE !== null &&
    process.env.AD_CONTAINERS_TRACE !== undefined &&
    process.env.AD_CONTAINERS_TRACE !== ''
    ? true
    : false;
const TRACE_BREAKPOINT = process.env.AD_CONTAINERS_TRACE === '1' ? 'A' : process.env.AD_CONTAINERS_TRACE;
exports._trace = ENABLE_TRACING
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (message, ...optionalMessages) {
            if (message === undefined || message === null || message === TRACE_BREAKPOINT) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                console.log(...optionalMessages);
            }
        }
    : () => {
        /**/
    };
const isDefined = (thing) => typeof thing !== 'undefined';
exports.isDefined = isDefined;
const isTruthy = (anyThing) => anyThing !== undefined &&
    anyThing !== null &&
    anyThing !== '' &&
    anyThing !== 0 &&
    anyThing !== false &&
    !Number.isNaN(anyThing);
exports.isTruthy = isTruthy;
//# sourceMappingURL=lib.js.map